export class UpdateDashboardInput {
    'name';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateDashboardInput.attributeTypeMap;
    }
    constructor() {
    }
}
